import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './FlexLayoutUndoRedoToolbar.css'

/// region Store

export class FlexLayoutUndoRedoToolbarStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const toDispose: Array<IDisposer> = []

    return () => toDispose.forEach(d => d())
  }

  @observable foo = false

  @computed get bar() { return null }

  @action verb = () => {}
}

export const FlexLayoutUndoRedoToolbarStoreContext = React.createContext<FlexLayoutUndoRedoToolbarStore>(null)
export const useFlexLayoutUndoRedoToolbarStore = () => React.useContext(FlexLayoutUndoRedoToolbarStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const FlexLayoutUndoRedoToolbar = observer<MyProps>(function FlexLayoutUndoRedoToolbar({className, ...props}) {
  const obsProps = useAsObservableSource({props}),
    store = useVipLocalStore((stores) => new FlexLayoutUndoRedoToolbarStore(stores, obsProps)),
    {stores: {reports: {currentReport, currentReportModel}}} = store

  useEffect(() => store.registerEffects(), [])

  if (!currentReportModel || !currentReport?.isDraft) return null

  const {redo, undo, canRedo, canUndo} = currentReportModel

  return (
    <FlexLayoutUndoRedoToolbarStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <PrimaryIconButton icon='undo' tooltipPosition='bottom' tooltip='Undo' disabled={!canUndo} onClick={undo} />
        <PrimaryIconButton icon='redo' tooltipPosition='bottom' tooltip='Redo' disabled={!canRedo} onClick={redo}/>
      </div>
    </FlexLayoutUndoRedoToolbarStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/FlexLayoutUndoRedoToolbar.tsx